import React, { useMemo } from "react";
import style from "./index.module.scss";
import { SourceItem } from "../../../pages/ResourcePool/service";
import DocViewer from "./components/DocViewer";
import HtmlView from "./components/HtmlView";
import { Empty } from "antd";
import VideoViewer from "./components/VideoViewer";
import VideoLocalPlayer from "./components/VideoLocalPlayer";
import { CourseWareTypeList } from "../../../utils/common";

interface CourseWareViewerProps {
    data: SourceItem;
}

export default function CourseWareViewer({ data }: CourseWareViewerProps) {
    type keyType = keyof typeof CourseWareTypeList;
    const fileType = useMemo((): string => {
        for (let type of Object.keys(CourseWareTypeList)) {
            if (
                CourseWareTypeList[type as keyType].includes(
                    data?.sourceFileEntity?.fileType?.toLowerCase()
                )
            ) {
                return type;
            }
        }
        return "";
    }, [data]);

    const viewUrl = useMemo(() => {
        if (["ppt", "word", "excel"].includes(fileType)) {
            return (
                data?.sourceFileEntity?.officeViewUrl ||
                `https://view.officeapps.live.com/op/embed.aspx?src=${data?.sourceFileEntity?.viewUrl}`
            );
        } else {
            return data?.sourceFileEntity?.viewUrl || "";
        }
    }, [data, fileType]);

    return (
        <div className={style.root}>
            {fileType === "video" && viewUrl.includes("http") && (
                <VideoLocalPlayer src={viewUrl} />
            )}
            {fileType === "video" && !viewUrl.includes("http") && (
                <VideoViewer vid={viewUrl} />
            )}
            {["ppt", "word", "excel", "pdf", "pic"].includes(fileType) && (
                <DocViewer src={viewUrl} />
            )}
            {["href", "polyv"].includes(fileType) && (
                <HtmlView key={viewUrl} src={viewUrl} />
            )}
            {![
                "ppt",
                "word",
                "excel",
                "pdf",
                "pic",
                "href",
                "polyv",
                "video"
            ].includes(fileType) && (
                <div className={style.center}>
                    <Empty description="当前文件格式不支持预览，请下载到本地查看" />
                </div>
            )}
        </div>
    );
}
